<span
  *ngIf="counter >= warningThreshold"
  class="badge"
  [ngClass]="{ 'badge--danger': isBadgeDangered(counter), 'badge--warning': isBadgeWarned(counter) }"
>
  {{ counter }}
</span>
